// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let AlertMessage = function (fieldSet)
{
    this.Code = Message.CODE_ALERT_MESSAGE
    PFixMessage.call(this, fieldSet)
}

AlertMessage.prototype = Object.create(PFixMessage.prototype)

AlertMessage.prototype.getUserId = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_USER_ID)
}

AlertMessage.prototype.getTradableInstrumentId = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID)
}

AlertMessage.prototype.getRouteId = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ROUTE_ID)
}

AlertMessage.prototype.getAlertId = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ALERT_ID)
}

AlertMessage.prototype.getAlertType = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ALERT_TYPE)
}

AlertMessage.prototype.getAlertCondition = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ALERT_CONDITION)
}

AlertMessage.prototype.getAlertValue = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ALERT_VALUE)
}

AlertMessage.prototype.getAlertImportance = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ALERT_IMPORTANCE)
}

AlertMessage.prototype.getAlertDate = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_DATE)
}

AlertMessage.prototype.getAlertAfterExecute = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ALERT_AFTER_EXECUTE)
}

AlertMessage.prototype.getAlertAction = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ALERT_ACTION)
}

AlertMessage.prototype.getAlertNotification = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ALERT_NOTIFICATION)
}

AlertMessage.prototype.getAlertText = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_TEXT)
}

AlertMessage.prototype.getAlertEvent = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ALERT_EVENT)
}

AlertMessage.prototype.getAlertStatus = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ALERT_STATUS)
}